// src/services/foSegmentRAPService.js
import api from '../config/axios';

const BASE_PATH = '/fo-segment-rap';

// ============= Query Operations =============

/**
 * Get all RAPs for a segment
 */
export const getRAPsBySegmentId = async (segmentId) => {
  const timestamp = new Date().getTime();
  const response = await api.get(`${BASE_PATH}/segment/${segmentId}?_t=${timestamp}`);
  return response.data;
};

/**
 * Get RAP by segment and category
 */
export const getRAPBySegmentAndCategory = async (segmentId, categoryId) => {
  const timestamp = new Date().getTime();
  const response = await api.get(
    `${BASE_PATH}/segment/${segmentId}/category/${categoryId}?_t=${timestamp}`
  );
  return response.data;
};

/**
 * Get RAP by ID
 */
export const getRAPById = async (id) => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

/**
 * Check if RAP exists for segment and category
 */
export const checkRAPExists = async (segmentId, categoryId) => {
  const response = await api.get(
    `${BASE_PATH}/segment/${segmentId}/category/${categoryId}/exists`
  );
  return response.data.exists;
};

/**
 * Get BOQ vs RAP summary
 */
export const getBOQRAPSummary = async (segmentId, categoryId) => {
  const response = await api.get(
    `${BASE_PATH}/segment/${segmentId}/category/${categoryId}/summary`
  );
  return response.data;
};

// ============= Command Operations =============

/**
 * Create or Update RAP
 */
export const saveRAP = async (rapData) => {
  const response = await api.post(BASE_PATH, rapData);
  return response.data;
};

/**
 * Delete RAP
 */
export const deleteRAP = async (id) => {
  await api.delete(`${BASE_PATH}/${id}`);
};

/**
 * Approve RAP
 */
export const approveRAP = async (id, approverName = 'System') => {
  const response = await api.post(`${BASE_PATH}/${id}/approve`, {
    approverName
  });
  return response.data;
};

/**
 * Unapprove RAP
 */
export const unapproveRAP = async (id) => {
  const response = await api.post(`${BASE_PATH}/${id}/unapprove`);
  return response.data;
};

// ============= Export Default =============

const foSegmentRAPService = {
  getRAPsBySegmentId,
  getRAPBySegmentAndCategory,
  getRAPById,
  checkRAPExists,
  getBOQRAPSummary,
  saveRAP,
  deleteRAP,
  approveRAP,
  unapproveRAP
};

export default foSegmentRAPService;